module.exports = __webpack_public_path__ + "static/media/NavbarLogo.7ff6d494.png";